<template>
  <swiper-base ref="swiper" class="swiper-type-six" :items="items" cycle="end" @change="onChange">
    <template v-slot:item="{ item }">
      <slot name="item" :item="item"></slot>
    </template>

    <template v-slot:buttons>
      <div class="swiper-type-six__buttons swiper-buttons">
        <bdi class="swiper-buttons__page u-typography-helvetica u-text u-text--m"
          >{{ currentPage }} / {{ totalPages }}</bdi
        >

        <u-icon-button
          class="swiper-buttons__button swiper-buttons__button--prev"
          icon-name="left"
          size="m"
          kind="secondary"
          @click="onSwipe('end')"
        />
        <u-icon-button
          class="swiper-buttons__button"
          icon-name="right"
          size="m"
          kind="secondary"
          @click="onSwipe('start')"
        />
      </div>
    </template>
  </swiper-base>
</template>

<script>
import { UIconButton } from 'universkin-shared';

import SwiperBase from '@/components/common/app-swiper/SwiperBase.vue';

export default {
  name: 'SwiperTypeSix',
  components: { SwiperBase, UIconButton },
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  data() {
    return { currentItemIndex: 0 };
  },
  computed: {
    totalPages() {
      return this.items.length;
    },
    currentPage() {
      return this.currentItemIndex + 1;
    }
  },
  methods: {
    onSwipe(direction) {
      this.$refs.swiper.swipeInDirection(direction);
    },
    onChange(index) {
      this.currentItemIndex = index;
      this.$emit('change', index);
    }
  }
};
</script>

<style lang="scss" scoped>
.swiper-type-six {
  position: relative;
  --item-width: 100%;
  --item-gap: 32px;

  &__buttons {
    margin-top: 16px;
  }
}

.swiper-buttons {
  display: flex;
  align-items: center;

  &__button {
    &:lang(ar) {
      transform: scaleX(-1);
    }
  }

  &__button--prev {
    margin-inline-end: 16px;
    margin-inline-start: 24px;
  }
}
</style>
